import { IconButton, colors, flex1, fullSize, fullWidth } from '@toilet-paper-games/ui';
import { HeartFill } from 'react-bootstrap-icons';
import { URLs } from '../utils/url';
export const DonateButton = () => {
  return (
    <a
      href={URLs.donate}
      target="_blank"
      rel="noopener noreferrer"
      css={[{ textDecoration: 'none' }, flex1]}
    >
      <IconButton
        css={[fullSize]}
        icon={<HeartFill css={[{ color: colors.danger }]} />}
        shadow
      >
        Donate
      </IconButton>
    </a>
  );
};
